import { render, staticRenderFns } from "./listWords.vue?vue&type=template&id=01683594&scoped=true"
import script from "./listWords.vue?vue&type=script&lang=js"
export * from "./listWords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01683594",
  null
  
)

export default component.exports